const SuggestionMenu = {
	how_improve: 'How can we improve?',
	placeholder: 'Quick summary about your suggestion',
	pending: 'Pending',
	in_progress: 'In Progress',
	completed: 'Completed',
	search: 'Search'
}

export default SuggestionMenu;